module.exports = __webpack_public_path__ + "img/lasource-23.d7c32a0d.jpg";